import { render } from "./blockA.vue?vue&type=template&id=91649788&scoped=true"
import script from "./blockA.vue?vue&type=script&lang=js"
export * from "./blockA.vue?vue&type=script&lang=js"

import "./blockA.vue?vue&type=style&index=0&id=91649788&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_e6684e1c54ce0e601933c41c13e63276/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91649788"]])

export default __exports__